'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './articles.routes';

export class ArticlesComponent {
    /*@ngInject*/
    constructor($http, $location, $stateParams, searchService, $state, $anchorScroll, $scope, $sce) {
        this.message = 'Hello';
        this.$http = $http;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.searchService = searchService;
        this.$state = $state;
        this.$sce = $sce;
        this.hasKey = false;
        this.$anchorScroll = $anchorScroll;
        this.$scope = $scope;
        this.filteredArticles = [];

    }

    $onInit() {
        this.$scope.baseURL = this.searchService.getBaseURL();

        var params = this.searchService.getSearchParams();
        console.log(params);
        var key;

        //Check if key exists in service
        if (this.searchService.getKey()) {
            key = this.searchService.getKey();
            this.hasKey = true;
        } else if (this.$location.search().key) {
            key = this.$location.search().key;
            this.hasKey = true;
        } else {
            this.hasKey = false;
        }

        //If no key exists in url, add parameter
        if (!this.$location.search().key) {
            console.log(key);

            this.$location.search('key', key);
        }

        //Check if search parameter and key, and set url parameters 
        if (params.q && key) {
            this.$location.url('?q=' + params.q + '&key=' + key);
        } else if (params.category) {
            this.$location.url("?category=" + params.category + '&key=' + key);
        }

        var searchParams = this.$location.search();
        this.searchService.setKey(key);

        this.key = key;
        //Check key for nav access
        this.$http.get(`${this.$scope.baseURL}/api/cw/client/${key}`)
            .then(response => {
                this.$scope.client = response.data[0];
                console.log(this.$scope.client);
            });

        //Load main page if no search parameters
        if (_.isEmpty(searchParams)) {
            this.$state.go('main');
        }

        if (!key) {
            key = 0;
        }
        if (searchParams.q) {
            this.$http.get(`${this.$scope.baseURL}/api/articles/tag/${searchParams.q}/${key}`)
                .then(response => {
                    console.log(response.data);
                    this.filteredArticles = response.data;
                    this.filteredArticles.forEach(element => {
                        element.leadIn = this.$sce.trustAsHtml(element.leadIn);
                        element.title = this.$sce.trustAsHtml(element.title);
                    });
                })
                .catch(err => {
                    console.log(err);
                })
        } else if (searchParams.category) {
            this.$http.get(`${this.$scope.baseURL}/api/data/category/${searchParams.category}/${key}`)
                .then(response => {
                    this.newTags = [];
                    console.log(response.data);
                    this.filteredArticles = response.data;
                    this.filteredArticles.forEach(element => {
                        element.leadIn = this.$sce.trustAsHtml(element.leadIn);
                        element.title = this.$sce.trustAsHtml(element.title);
                    });
                    
                })
                .catch(err => {
                    console.log(err);
                    if (err.data === 'Forbidden') {
                        this.hasKey = false;
                    }
                })
        }

        // this.$http.get('assets/js/diabetes.json')
        //     .then(results => {
        //         console.log(searchParams.q);
        //         this.articles = results.data;
        //         console.log(this.articles);
        //         this.allArticles = this.articles;

        //         if (searchParams.q) {
        //             this.filteredArticles = _.filter(this.articles, function(o) {
        //                 var tagsList = o.Index['Tag Categories'].split(',');
        //                 for (var index = 0; index < tagsList.length; index++) {
        //                     // console.log('searchParam', searchParams.q);
        //                     // console.log('tagParam', tagsList[index]);
        //                     var trimmedString = tagsList[index].trim();
        //                     console.log(trimmedString);
        //                     if (trimmedString === searchParams.q.trim()) {
        //                         console.log('match');
        //                         return o;
        //                     }

        //                 }
        //             });
        //         } else if (searchParams.category) {
        //             this.filteredArticles = _.filter(this.articles, { 'General Heading': searchParams.category });
        //             // console.log(this.filteredArticles);
        //         }

        //         console.log(this.filteredArticles);

        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });

    }

    viewArticle(data) {
        console.log(data);
        this.searchService.setArticle(data);
        this.searchService.setInitiative({});
        this.$state.go('article');
    }

    viewVideo(data) {
        console.log(data);
        this.searchService.setArticle(data);
        this.$state.go('articleVideo');
    }

    backToSearch(type) {
        this.$location.url('/#' + type);
        this.$anchorScroll(type);
    }
}

export default angular.module('connectwellTemplateApp.articles', [uiRouter])
    .config(routes)
    .component('articles', {
        template: require('./articles.html'),
        controller: ArticlesComponent,
        controllerAs: 'articlesCtrl'
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/articles/articles.component.js